import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { listProducts } from '../api/products';
import Rack from '../components/Rack';

function formatPrice(cents) {
  return '$' + (cents / 100).toFixed(2);
}

const CATEGORIES = [
  { value: '', label: 'All Products' },
  { value: 'rack', label: 'Display Racks' },
  { value: 'accessory', label: 'Accessories' },
];

function previewRowsFor(p) {
  const slug = p.slug || '';
  const n = p.options?.modules
    || (slug.includes('wall') ? 5 : slug.includes('four') ? 4 : slug.includes('back') ? 3 : slug.includes('pair') ? 2 : 1);
  if (n === 5) return [{ color: 'blue' }, { color: 'white' }, { color: 'red' }, { color: 'blue' }, { color: 'white' }];
  if (n === 4) return [{ color: 'blue' }, { color: 'red' }, { color: 'white' }, { color: 'blue' }];
  if (n === 3) return [{ color: 'blue' }, { color: 'white' }, { color: 'red' }];
  if (n === 2) return [{ color: 'blue' }, { color: 'red' }];
  return [{ color: 'blue' }];
}

export default function Shop() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchParams, setSearchParams] = useSearchParams();
  const category = searchParams.get('category') || '';

  useEffect(() => {
    setLoading(true);
    listProducts(category || undefined)
      .then(res => setProducts(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [category]);

  return (
    <div className="container section">
      <div style={{ textAlign: 'center', marginBottom: '48px' }}>
        <div className="mono" style={{ marginBottom: '12px' }}>Catalog</div>
        <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(2rem, 5vw, 3rem)', fontWeight: 300 }}>Shop All Products</h1>
        <p style={{ color: 'var(--cream-dim)', maxWidth: '500px', margin: '16px auto 0', lineHeight: '1.7', fontWeight: 300 }}>
          Modular display racks, handcrafted for the golf balls that mean the most.
        </p>
      </div>

      <div style={{ display: 'flex', gap: '8px', justifyContent: 'center', marginBottom: '40px', flexWrap: 'wrap' }}>
        {CATEGORIES.map(cat => (
          <button
            key={cat.value}
            className="mono"
            onClick={() => setSearchParams(cat.value ? { category: cat.value } : {})}
            style={{
              padding: '10px 24px',
              border: category === cat.value ? '1px solid var(--gold)' : '1px solid rgba(201,168,76,0.2)',
              background: category === cat.value ? 'var(--gold)' : 'transparent',
              color: category === cat.value ? 'var(--ink)' : 'var(--cream-dim)',
              fontSize: '0.6rem',
              letterSpacing: '0.2em',
              transition: 'all 0.3s',
              cursor: 'pointer',
            }}
          >
            {cat.label}
          </button>
        ))}
      </div>

      {loading ? (
        <p style={{ textAlign: 'center', color: 'var(--cream-dim)', padding: '60px 0' }}>Loading...</p>
      ) : products.length === 0 ? (
        <p style={{ textAlign: 'center', color: 'var(--cream-dim)', padding: '60px 0' }}>No products found.</p>
      ) : (
        <div className="product-grid">
          {products.map(p => (
            <Link to={`/shop/${p.slug}`} key={p.slug} className="product-card">
              <div className="product-card-img product-card-img-rack">
                {p.images?.[0] ? (
                  <img src={p.images[0]} alt={p.name} />
                ) : p.category === 'rack' ? (
                  <div className="product-rack-preview">
                    <Rack rows={previewRowsFor(p)} />
                  </div>
                ) : (
                  <div className="product-card-empty">No image</div>
                )}
              </div>
              <div className="product-card-body">
                <div className="product-card-name">{p.name}</div>
                <div className="product-card-price">
                  {formatPrice(p.price_cents)}
                  {p.compare_price_cents && (
                    <span className="product-card-compare">{formatPrice(p.compare_price_cents)}</span>
                  )}
                </div>
                {p.description && (
                  <p style={{ color: 'var(--cream-dim)', fontSize: '0.85rem', marginTop: '8px', lineHeight: '1.5', fontWeight: 300 }}>
                    {p.description.slice(0, 80)}{p.description.length > 80 ? '...' : ''}
                  </p>
                )}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
